import usePendingState from '../../Hooks/usePendingState';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';

const FormAddGroup = () => {
    const { setNotification } = useNotification();
    const [loading, setLoading] = useState(true);
    const [groupData, setGroupData] = useState({
        nome: '',
        tipo: '',
    });

    const [groupErrorData, setGroupErrorData] = useState({
        nome: [],
        tipo: [],
    });

    const [formLoading, setFormLoading, formPendingRef] = usePendingState();

    const navigate = useNavigate();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setGroupData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSelectChange = (name, selectedOption) => {
        setGroupData((prevData) => ({
            ...prevData,
            [name]: selectedOption.value,
        }));
    };

    useEffect(() => {
        setLoading(false);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formPendingRef.current) return;
        setFormLoading(true);

        try {
            const response = await fetch(`${baseUrl}/manager/grupos/novo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(groupData),
            });
            if (response.ok) {
                setNotification({
                    type: 'success',
                    message: 'Grupo adicionado com sucesso!',
                    show: true,
                });
                navigate('/manager/categorias');
            } else {
                if (response.status === 422) {
                    const errors = await response.json();
                    setGroupErrorData(errors);
                } else {
                    throw new Error('Erro ao adicionar novo grupo.');
                }
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setFormLoading(false);
        }
    };

    const types = [
        { value: 'imagem', label: 'Imagem' },
        { value: 'material', label: 'Material' },
        { value: 'video', label: 'Vídeo' },
    ];

    if (loading)
        return (
            <div className="mx-auto py-20 flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent" />
            </div>
        );

    return (
        <>
            <Link
                to="/manager/categorias"
                className="bg-slate-100 px-4 py-1.5 rounded border border-slate-300 float-right ml-2 transition-all hover:bg-slate-200"
            >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                Voltar
            </Link>

            <h4 className="mb-6 text-xl font-bold text-black">Adicionar grupo</h4>

            <div className="flex flex-col">
                <form onSubmit={handleSubmit} className="max-w-5xl pb-10">
                    <div className="mb-6 2xl:mb-10">
                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full lg:w-3/4">
                                <label className="block text-sm font-medium mb-1">Nome</label>
                                <input
                                    type="text"
                                    name="nome"
                                    value={groupData.nome}
                                    onClick={() => setGroupErrorData((prevData) => ({ ...prevData, nome: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {groupErrorData.nome && groupErrorData.nome[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {groupErrorData.nome[0]}{' '}
                                        <span
                                            onClick={() => setGroupErrorData((prevData) => ({ ...prevData, nome: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full lg:w-3/4">
                                <label className="block text-sm font-medium mb-1">Tipo de Grupo</label>
                                <Select
                                    name="tipo"
                                    options={types}
                                    onClick={() => setGroupErrorData((prevData) => ({ ...prevData, tipo: [] }))}
                                    onChange={(selectedOption) => handleSelectChange('tipo', selectedOption)}
                                    placeholder="Selecione uma opção..."
                                    classNamePrefix="admin-select"
                                    className="group-select"
                                />
                                {groupErrorData.tipo && groupErrorData.tipo[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {groupErrorData.tipo[0]}{' '}
                                        <span
                                            onClick={() => setGroupErrorData((prevData) => ({ ...prevData, tipo: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={formLoading}
                        aria-busy={formLoading}
                        className="w-full lg:w-3/4 bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    >
                        {!formLoading ? 'Salvar' : <Loading />}
                    </button>
                </form>
            </div>
        </>
    );
};

export default FormAddGroup;
